var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
export var SubpanelDisplayOptions = function (_a) {
    var preferences = _a.preferences, onUpdate = _a.onUpdate;
    var t = useTranslation(["common", "app_strings"]).t;
    var _b = useState(preferences), configs = _b[0], setConfigs = _b[1];
    var _c = useState(false), useTabView = _c[0], setUseTabView = _c[1];
    useEffect(function () {
        onUpdate(configs);
    }, [configs]);
    useEffect(function () {
        setConfigs(preferences);
    }, [preferences]);
    return (_jsxs("div", __assign({ className: "bg-white rounded-md" }, { children: [_jsx("h3", __assign({ className: "text-lg font-semibold text-gray-900 mb-2 border-b-2 uppercase pb-4" }, { children: t("LBL_SUBPANEL_OPTION", { ns: "Users" }) })), _jsx("div", __assign({ className: "space-y-4" }, { children: _jsxs("div", __assign({ className: "flex items-center justify-between" }, { children: [_jsx("div", __assign({ className: "flex flex-col" }, { children: _jsx("span", __assign({ className: "mt-1" }, { children: t("LBL_PREVIEW_SUBPANEL", { ns: "Users" }) })) })), _jsx("label", __assign({ className: "relative inline-flex items-center cursor-pointer" }, { children: _jsx("input", { name: "use_tab_view", className: "checkbox", type: "checkbox", checked: configs.USE_TAB_VIEW, onChange: function (e) {
                                    setUseTabView(!useTabView);
                                    setConfigs(__assign(__assign({}, configs), { USE_TAB_VIEW: !useTabView }));
                                } }) }))] })) }))] })));
};
